import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Brand } from "../components/Layout";
import { Field, FormError } from "../components/Common";
import { Button } from "../components/ui/button";

const Radar = () => (
  <div className="relative mx-auto aspect-square w-full max-w-md">
    {[100, 75, 50, 25].map((s) => (
      <div key={s} className="absolute rounded-full border border-emerald-500/20"
        style={{ inset: `${(100 - s) / 2}%` }} />
    ))}
    <div className="absolute inset-0 overflow-hidden rounded-full"><div className="radar-sweep h-full w-full rounded-full" /></div>
    <div className="absolute left-[30%] top-[35%] h-2 w-2 animate-pulse rounded-full bg-rose-500 shadow-[0_0_12px_#f43f5e]" />
    <div className="absolute left-[62%] top-[58%] h-2 w-2 rounded-full bg-amber-400 shadow-[0_0_12px_#f59e0b]" />
    <div className="absolute left-[55%] top-[25%] h-2 w-2 rounded-full bg-emerald-400 shadow-[0_0_12px_#10b981]" />
  </div>
);

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) return setError("Preencha o email e a palavra-passe.");
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err?.response?.status === 401 ? "Email ou palavra-passe incorretos." : errMsg(err, "Não foi possível iniciar sessão."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen grid-bg lg:grid-cols-[1.1fr_1fr]">
      <section className="hidden flex-col justify-between border-r border-slate-800 bg-slate-950/60 p-12 lg:flex">
        <Brand />
        <Radar />
        <div>
          <div className="eyebrow">QBCore · Guerra de Territórios</div>
          <p className="mt-3 max-w-md text-slate-400">Controle zonas, mesas de craft e guerras entre organizações em tempo real.</p>
        </div>
      </section>
      <section className="flex items-center px-8 py-16 sm:px-16">
        <form onSubmit={submit} className="fade-up w-full max-w-sm space-y-6" data-testid="login-form" noValidate>
          <div className="lg:hidden"><Brand /></div>
          <div>
            <div className="eyebrow">Acesso restrito</div>
            <h1 className="mt-2 text-4xl font-bold uppercase tracking-wider">Entrar</h1>
            <p className="mt-2 text-sm text-slate-400">Painel de administração do sistema de domínio.</p>
          </div>
          <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} testid="login-email-input" placeholder="admin@domina.pt" autoComplete="username" />
          <Field label="Palavra-passe" type="password" value={password} onChange={(e) => setPassword(e.target.value)} testid="login-password-input" autoComplete="current-password" />
          <FormError message={error} testid="login-error" />
          <Button type="submit" disabled={busy} data-testid="login-submit-button"
            className="h-11 w-full bg-emerald-500 font-display uppercase tracking-[0.2em] text-slate-950 hover:bg-emerald-400">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Entrar"}
          </Button>
          <a href="/ranking" className="block text-center font-mono text-xs uppercase tracking-widest text-slate-500 hover:text-amber-300" data-testid="login-public-ranking-link">
            Ver ranking público →
          </a>
        </form>
      </section>
    </div>
  );
}
